import { useState } from 'react';
import SimpleBar from 'simplebar-react';
import { SchedulingByDataModel } from '../../../../models/requests-management/workshift&Interruption';
import { Controls } from '../controls/Controls';
import { SchedulingCard } from './schedulings-cards/SchedulingCard';
import { DataInfoExtendedProps, DetailsModal } from '../modals/DetailsModal';

interface MobileCalendarProps {
    schedulings: SchedulingByDataModel[];
    prevMonth: () => void;
    nextMonth: () => void;
    currentDate: Date;
    handlerCreateRequestFromButton: (
        type: string,
        startDate: string,
        endDate: string,
        startHour: string,
        endHour: string,
        info?: DataInfoExtendedProps
    ) => void;
}

export const MobileCalendar = ({
    schedulings,
    handlerCreateRequestFromButton,
    nextMonth,
    prevMonth,
    currentDate,
}: MobileCalendarProps) => {
    const [isOpenDetails, setIsOpenDetails] = useState(false);
    const [detailsInfo, setDetailsInfo] = useState<any>({});

    return (
        <div className='mobileCalendar'>
            <div className='mobileCalendar__wrapper'>
                <Controls
                    month={currentDate.getMonth()}
                    nextMonth={nextMonth}
                    prevMonth={prevMonth}
                />

                <div className='mobileCalendar__section mt-2'>
                    <SimpleBar
                        style={{
                            width: '100%',
                            maxHeight: 'calc(100vh - 200px)',
                            height: 'calc(100vh - 200px)',
                        }}
                    >
                        {Array.from(
                            {
                                length: new Date(
                                    new Date().getFullYear(),
                                    currentDate.getMonth() + 1,
                                    0
                                ).getDate(),
                            },
                            (_, index) => {
                                return (
                                    <SchedulingCard
                                        day={index + 1}
                                        month={currentDate.getMonth()}
                                        year={currentDate.getFullYear()}
                                        workshiftScheduling={schedulings.find(
                                            (s) =>
                                                new Date(
                                                    s.date.split('T')[0] +
                                                        'T05:00:00'
                                                ).getDate() ==
                                                index + 1
                                        )}
                                        setDetailsInfo={setDetailsInfo}
                                        setIsOpenDetails={setIsOpenDetails}
                                    />
                                );
                            }
                        )}
                    </SimpleBar>
                </div>
            </div>

            {isOpenDetails && (
                <DetailsModal
                    handlerCreateRequestFromButton={handlerCreateRequestFromButton}
                    isOpen={isOpenDetails}
                    onClose={setIsOpenDetails}
                    detailsInfo={detailsInfo}
                />
            )}
        </div>
    );
};
